export class Settings {
  static INACTIVITY_TIMEOUT = 'inactivityTimeout';
  static SETTINGS_SYNC_INTERVAL = 'settingsSyncInterval';
  static BASKET_AUTO_SUBMIT_DELAY = 'basketAutoSubmitDelay';
  static STOCK_RETURN_LOCATION = 'stockReturnLocation';
  static CAN_RETURN_TO_ANY_LOCATION = 'canReturnToAnyLocation';
  static APPLICATION_UPDATE_INTERVAL = 'applicationUpdateInterval';
  static FORCE_CLIENT_UPDATE = 'forceClientUpdate';
  static BASKET_RETRY_INTERVAL = 'basketRetryInterval';
  static BASKET_TIME_TO_LIVE = 'basketTimeToLive';
  static PASSWORD_VALIDATOR = 'passwordValidator';
  static DEVICE_STATUS_CHECK = 'deviceStatusCheck';
  static DISCHARGED_PATIENT_DAYS_TO_SUBTRACT = 'days_to_subtract';
  static WHITEBOARD_REFRESH_INTERVAL = 'whiteboardRefreshInterval';
  static THEATRE_REFRESH_INTERVAL = 'theatreRefreshInterval';
  static THEATRE_MAX_DOCTORS = 'max_doctors';
  static THEATRE_MAX_PROCEDURES = 'max_procedures';
  static THEATRE_MAX_ANAESTHETISTS = 'max_anaesthetists';
  static GET_DOCTORS_INTERVAL = 'getDoctorsInterval';
  static GET_PROCEDURES_INTERVAL = 'getProcedureListIntervalDefinition';
  static GET_SERVICES_INTERVAL = 'getServiceListIntervalDefinition';
  static THEATRE_PACKS_ENABLED = 'theatrePacksManagement';
  static WHITEBOARD_EMPTY_BEDS_ENABLED = 'enableWhiteboardEmptyBeds';
  static ENABLE_DEFAULT_PROCEDURE_MATERIALS = 'enableDefaultProcedureMaterials';
  static ENABLE_ACTION_CENTER = 'enableActionCenter';
  static ENABLE_FREE_TEXT_THEATRE_PROCEDURE = 'enableFreeTextTheatreProcedure';
  static ACCESS_FREE_TEXT_PROCEDURE_VIA_PROCEDURE_LIST = 'accessFreeTextProcedureViaProcedureList';
  static DELAY_THEATRE_BASKET_SUBMISSION_BY_HOSPITAL = 'delayTheatreBasketSubmissionByHospital';
  static ENABLE_INDEXED_DB = 'enable_indexed_storage';
  static ENABLE_THEATRE_VIEW_ON_SMALL_DEVICE = 'enableTheatreViewOnSmallDevice';
  static DEACTIVATE_DEVICE_INTERVAL = 'deactivateDeviceInterval';
  static AUTO_APPROVE_TO_SAME_LOCATION = 'autoApproveToSameLocation';
  static AUTO_START_THEATRE_TIMER = 'autoStartTheatreTimer';
  static DELAY_THEATRE_BASKET_SUBMISSION_TIME = 'delayTheatreBasketSubmissionTime';
  static ENABLE_ADD_PACK_WITH_UNAVAILABLE_MATERIALS = 'enableAddPackWithUnavailableMaterials';
  static ENABLE_PACK_MATERIAL_DECREASE_QUANTITY = 'enablePackMaterialDecreaseQuantity';
  static ENABLE_PACK_MATERIAL_DELETION = 'enablePackMaterialDeletion';
  static ENABLE_PACK_MATERIAL_INCREASE_QUANTITY = 'enablePackMaterialIncreaseQuantity';
  static GET_MATERIALS_IN_WARD_INTERVAL = 'getMaterialsInWardInterval';
  static GET_PATIENTS_IN_WARD_INTERVAL = 'getPatientsInWardInterval';
  static GET_ROOMS_IN_WARD_INTERVAL = 'getRoomsInWardInterval';
  static HIDE_MATERIALS_NO_POSITIVE_STOCK_LEVEL = 'hideMaterialsThatDoNotHaveAPositiveStockLevel';
  static USER_PIN_LENGTH = 'userPinLength';
  static ENABLE_OPERATING_ROOM_FILTER = 'enableOperatingRoomFilter';
  static ENABLE_SELECTING_FROM_PROCEDURE_LIST = 'enableSelectingFromProcedureList';
  static MAX_PATIENTS_PER_OPERATING_ROOM = 'maxPatientsPerOperatingRoom';
  static DELAY_BETWEEN_SCANNING_IN_MILLISECONDS = 'delayBetweenScanningInMilliseconds';
  static CASE_NUMBER_LEADING_PADDING_CHARACTER = 'caseNumberLeadingPaddingCharacter';
  static CASE_NUMBER_LENGTH = 'caseNumberLength';
  static WARDS_TO_EXCLUDE_FROM_STOCK_TRANSFER = 'wardsToExcludeFromStockTransfer';
  static WARDS_TO_EXCLUDE_FROM_EMERGENCY_CUPBOARD = 'wardsToExcludeFromEmergencyCupboard';
  static ROOMS_TO_SKIP_WAITING_AND_RECOVERY = 'roomsToSkipWaitingAndRecovery';
  static ENABLE_CUSTOM_KEYBOARD = 'enableCustomKeyboard';
  static WARDS_TO_SYNC_MATERIALS = 'wardsToSyncMaterialsDefinition';
  static ENABLE_PACKS_FOR_NORMAL_WARD_BILLING = 'enablePacksForNormalWardBilling';
  static ENABLE_PACK_MANAGEMENT = 'enablePackManagement';
  static ENABLE_EMAILS_FOR_MATERIALS_WITH_NO_STOCK = 'enableEmailsForMaterialsWithNoStock';
  static EMAILS_TO_RECEIVE_NO_ST0CK_SUMMARY = 'emailsToReceiveNoStockSummary';
  static EMAILS_TO_RECEIVE_NO_STOCK_ALERTS = 'emailsToReceiveNoStockAlerts';
  static ENABLE_MOVING_PATIENTS_BETWEEN_OPERATING_ROOMS = 'enableMovingPatientsBetweenOperatingRooms';
  static ENABLE_REQUEST_TRAINING = 'enableRequestTraining';
  static ENABLE_LINK_EXISTING_DEVICE = 'enableLinkExistingDevice';
  static KRONOS_LOGIN_SCREEN = 'KronosLoginScreen';
  static KRONOS_SCHEDULE = 'EmployeeMasterDataFromKronosSchedule';
  static SURVEY_SCHEDULE = 'EscalationPathCronSchedule';
  static ENABLE_PATIENT_NOTES = 'enablePatientNotes';
  static ENABLE_MY_VOICE_SURVEYS = 'enableMyVoiceSurveys';
  static ENABLE_STOCK_TRANSFER_APPROVALS = 'enableStockTransferApprovals';
  static OTP_TIMEOUT = 'OTPTimeout';
  static TIME_LIMIT_TO_DETECT_INPUT_AS_SCANNER = 'timeLimitToDetectInputAsScanner';
  static ENABLE_STOCK_COUNTING = 'enableStockCounting';
  static ENABLE_TIS_SCORING = 'enableTisScoring';
  static USE_NEW_MENU_STRUCTURE = "useNewMenuStructure";
  static METABASE_LINK = "metabaseLink";
  static METABASE_KEY = "metabaseKey";
  static METABASE_WEEKLY = "metabaseWeekly";
  static METABASE_MONTHLY = "metabaseMonthly";
  static METABASE_WHO_COMPLIANCE = "metabaseWhoCompliance";
  static ENABLE_AI = "enableAI";
  static MESSAGING = "messaging";
  static MESSAGING_INTERVAL = "messagingInterval";
  static ENABLE_CHECKLIST = "enableChecklist";
	static FORCE_COMPLETE_CHECKLIST_ON_RECOVERY = "forceCompleteChecklistOnRecovery";
  static TIS_SCORING_DELIVERY_REPORT_INTERVAL = "tisScoringDeliveryReportInterval";
  static METABASE_TIS_SCORING = "metabaseTisScoring";
}
